import { render, staticRenderFns } from "./DownloadProgress.vue?vue&type=template&id=2c645408&scoped=true"
import script from "./DownloadProgress.vue?vue&type=script&lang=js"
export * from "./DownloadProgress.vue?vue&type=script&lang=js"
import style0 from "./DownloadProgress.vue?vue&type=style&index=0&id=2c645408&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c645408",
  null
  
)

export default component.exports